export default "__VITE_ASSET__v1qEaXZ6__"